exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-header[data-v-4005c997]{position:sticky;top:0;margin-top:20px;margin-bottom:10px;z-index:1}.list_item[data-v-4005c997]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:7px}.list_item .parent[data-v-4005c997]{height:30px;line-height:30px;text-align:center;background-color:#f5f5f5}.list_item .label[data-v-4005c997]{width:250px;text-align:right;line-height:35px}.list_item .remark[data-v-4005c997]{padding:0 20px;width:30%}\n", ""]);

// exports
